import React from "react";
import AboutMe from "./AboutMe";
import More from "./More";

const HomePage = () => {
  return (
    <div className="App">
      <AboutMe />
      <More />
    </div>
  );
};

export default HomePage;
